import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { authenticationService } from './authenticationService';

let expiration = null;

const expirationFunc = () => {
    expiration = setInterval(() => {
        // if offline then  repeat
        if (sessionStorage.getItem("isOffline") === "1") {
            expirationReset();
            return;
        }
        sessionStorage.removeItem("checkExpirationLoaded");
        document.removeEventListener('click', expirationReset);
        authenticationService.logout("0");
        clearInterval(expiration);
    }, 30 * 60 * 1000);
};

const expirationReset = () => {
    clearInterval(expiration);
    expirationFunc();
};

const checkUserIsActive = () => {
    let isCheckExpirationLoaded = sessionStorage.getItem("checkExpirationLoaded");

    if (isCheckExpirationLoaded !== '1') {
        sessionStorage.setItem("checkExpirationLoaded", '1');
        expirationFunc();
        document.addEventListener('click', expirationReset);
    }
};

const loadExpirationFunc = (props) => {
    let pageName = '';

    if (props && props.location.pathname) {
        pageName = props.location.pathname.substring(1, props.location.pathname.length);
    }

    if (pageName === '' || pageName === 'PatientSittingList') {
        checkUserIsActive();
    }
    else {
        sessionStorage.removeItem("checkExpirationLoaded");
        document.removeEventListener('click', expirationReset);
        clearInterval(expiration);
    }
}

export const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route {...rest} render={props => {
        const currentUser = authenticationService.currentUserValue;

        if (currentUser && currentUser.Token) {
            loadExpirationFunc(props);
            // authorised so return component
            return <Component {...props} />
        }

        // not logged in so redirect to login page with the return url
        return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
    }} />
)
